// extracted by mini-css-extract-plugin
export var wordContainer = "_nu-0";